// extracted by LIB_CSS_EXTRACT_LOADER
import "./focus-scope_module.css"
export default {"scope":"scope-YXkVYQ"};